<template>
  <el-dialog
    :title="isWxPopup ? '已发布的活动' : $t('common_46018')"
    width="900px"
    :lock-scroll="false"
    :visible="visible"
    @close="close"
  >
    <p style="color: #999;font-size: 12px;margin-bottom: 10px;" v-if="isWxPopup">小程序开屏弹窗仅支持在“活动发布”中已添加的在小程序“活动中心”中展示的活动。</p>
    <!-- 正常模式搜索区域 -->
    <div class="active-list" v-if="!isWxPopup">
      <div class="flex-container margint15 padding15 radius">
        <div class="flex-container-left">
          <div class="flex-container-left text-info">
            <el-input v-model="activityName" class="text-info" size="medium" style="width: 180px;margin-right: 20px;" :placeholder="$t('common_46008')"></el-input>
            <el-button icon="el-icon-search" size="medium" type="primary" @click="search">{{ $t('common_00255') }}</el-button>
          </div>
          <div class="flex-container-left text-info" style="margin:20px 0;">
            <label class="fs14 marginr15">{{ $t('common_46009') }}: </label>
            <el-radio-group v-model="statusType">
              <el-radio label="all">{{$t('common_46016')}}</el-radio>
              <el-radio label="0">{{$t('common_46012')}}</el-radio>
              <el-radio label="1">{{$t('common_46013')}}</el-radio>
              <el-radio label="2">{{$t('common_46014')}}</el-radio>
              <el-radio label="3">{{$t('common_46015')}}</el-radio>
            </el-radio-group>
          </div>
        </div>
      </div>
    </div>
    
    <!-- 微信模式搜索区域 -->
    <div class="active-list" v-if="isWxPopup">
      <div class="flex-container margint15 padding15 radius" style="margin-bottom: 20px;">
        <div class="flex-container-left">
          <div class="flex-container-left text-info">
            <el-input v-model="wxActivityName" class="text-info" size="medium" style="width: 180px;" :placeholder="$t('common_46008')"></el-input>
          </div>
        </div>
      </div>
    </div>

    <!-- 微信模式表格 -->
    <div class="e-table" v-if="isWxPopup">
      <el-table
        :key="'normal-table-' + toogleIndex"
        :header-cell-style="{height: '54px',fontSize: '14px',background:'#EFF2F6',color:'#1B2330',borderRadius: '4px 4px 0px 0px'}"
        :data="filteredWxTableData"
        highlight-current-row
        @current-change="handleCurrentChangeRadio">
        <el-table-column width="70">
          <template slot-scope="scope">
            <el-radio class="radio" v-model="currentRow" :label="scope.row">&nbsp;</el-radio>
          </template>
        </el-table-column>
        <el-table-column :label="$t('common_46008')" prop="promotionTitle">
          <template slot-scope="scope">
            {{ getWxTitle(scope.row) }}
          </template>
        </el-table-column>
        <el-table-column :label="$t('活动类型')" prop="type" width="120">
          <template slot-scope="scope">
            <span v-if="scope.row.link && scope.row.link.trim()">{{ getActivityTypeText(scope.row.type) }}</span>
            <span v-else>-</span>
          </template>
        </el-table-column>
        <el-table-column :label="$t('common_46010')" prop="link" width="200">
          <template slot-scope="scope">
            {{ scope.row.link || '-' }}
          </template>
        </el-table-column>
        <el-table-column :label="$t('common_46011')" prop="time" width="200">
          <template slot-scope="scope">
            {{ formatWxTime(scope.row.promotionStartTime, scope.row.promotionEndTime) }}
          </template>
        </el-table-column>
        <el-table-column :label="$t('common_46009')" prop="promotionStatus">
          <template slot-scope="scope">
            <span :class="getWxStatusClass(scope.row.promotionStatus)">{{getWxStatusText(scope.row.promotionStatus)}}</span>
          </template>
        </el-table-column>
        <el-table-column :label="$t('common_00282')" align="center">
          <template slot-scope="scope">
            <a v-if="scope.row.link && scope.row.link.trim()" class="text" :href="'./addStoredValue.html?id='+ scope.row.link +'&tag=' + tag.slice(1)" target='_blank'>
              <el-button class="fw400" type="text">{{$t('common_00229')}}</el-button>
            </a>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <!-- 正常模式表格 -->
    <div class="e-table" v-if="!isWxPopup">
      <el-table
        :key="'normal-table-' + toogleIndex"
        :header-cell-style="{height: '54px',fontSize: '14px',background:'#EFF2F6',color:'#1B2330',borderRadius: '4px 4px 0px 0px'}"
        :data="tableData"
        highlight-current-row
        @current-change="handleCurrentChangeRadio">
        <el-table-column width="70">
          <template slot-scope="scope">
            <el-radio class="radio" v-model="currentRow" :label="scope.row">&nbsp;</el-radio>
          </template>
        </el-table-column>
        <el-table-column :label="$t('common_46008')" prop="title">
          <template slot-scope="scope">
            {{ scope.row.title }}
          </template>
        </el-table-column>
        <el-table-column :label="$t('common_46010')" prop="id" width="230">
          <template slot-scope="scope">
            {{ scope.row.id }}
          </template>
        </el-table-column>
        <el-table-column :label="$t('common_46011')" prop="time" width="230">
          <template slot-scope="scope">
            {{ time(scope.row) }}
          </template>
        </el-table-column>
        <el-table-column :label="$t('common_46009')" prop="status" :formatter="status">
          <template slot-scope="scope">
            <span :class="status(scope.row, 1)">{{status(scope.row)}}</span>
          </template>
        </el-table-column>
        <el-table-column :label="$t('common_00282')" align="center">
          <template slot-scope="scope">
            <a class="text" :href="'./addStoredValue.html?id='+ scope.row.id +'&tag=' + tag.slice(1)" target="_blank">
              <el-button class="fw400" type="text">{{$t('common_00229')}}</el-button>
            </a>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <!-- 正常模式分页 -->
    <div class="flex-container-center" v-if="!isWxPopup">
      <el-pagination
        class="margint30 marginb30"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        layout="total, prev, pager, next, jumper"
        :total="dataNum">
      </el-pagination>
    </div>

    <!-- 确定按钮 -->
    <div class="dialog-footer" style="text-align: right; margin-top: 20px;">
      <el-button size="medium" type="primary" @click="submitActive">{{ $t('common_00234') }}</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { formmatTime } from "@/assets/utils/time";
import { requestUrl, ajax } from "@/assets/utils/network";

export default {
  props: {
    tag: {
      type: String,
      default: "#value",
    },
    isWxPopup: {
      type: Boolean,
      default: false,
    },
    visible: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    typeMap() {
      return 1 ? this.$t('stored_00020') : this.$t('stored_00021')
    },
    filteredWxTableData() {
      if (!this.wxActivityName.trim()) {
        return this.wxTableData;
      }
      return this.wxTableData.filter(item => {
        const title = this.getWxTitle(item);
        return title.toLowerCase().includes(this.wxActivityName.toLowerCase());
      });
    }
  },
  data() {
    return {
      toogleIndex: 1,
      activityName: "",
      statusType: "all",
      tableData: [],
      wxTableData: [], // 微信模式的数据
      currentPage: 1,
      dataNum: 10,
      val: '',
      loading: false,
      params: [],
      currentRow: "",
      tagMap: {
        '#value': '1,2,3',
        '#free': '4',
        '#sell': '8',
        '#charge': '9',
      },
      wxActivityName: "", // 新增的微信活动名称输入框的值
    };
  },
  watch: {
    visible(newVal) {
      console.log('visible changed:', newVal);
      if (newVal) {
        if (this.isWxPopup) {
          this.getWxPromotionList();
        } else {
          var type = this.tagMap[this.tag];
          var refundStats = requestUrl + "/promotion?type=" + type + "&from=0&length=4&returnCount=true";
          this.getPromotionList(refundStats);
        }
      }
    }
  },
  mounted() {
    console.log('activeListDialog mounted, visible:', this.visible, 'isWxPopup:', this.isWxPopup);
    if (this.isWxPopup) {
      // 微信弹窗模式，调用 /wechatApp/promotion 接口
      this.getWxPromotionList();
    } else {
      var type = this.tagMap[this.tag];
      var refundStats = requestUrl + "/promotion?type=" + type + "&from=0&length=4&returnCount=true";
      this.getPromotionList(refundStats);
    }
  },
  methods: {
    close() {
      this.$emit('close')
    },
    handleCurrentChangeRadio(val) {
      if (val) {
        this.currentRow = val;
        console.log(val)
      }
    },
    submitActive() {
      if (!this.currentRow) {
        return;
      }
      this.$emit('confirm', this.currentRow)
      console.log(this.currentRow)
    },
    formmatTime(time) {
      return formmatTime(time + "", false);
    },
    formatWxTime(startTime, endTime) {
      if (startTime && endTime) {
        return this.formmatTime(startTime) + " - " + this.formmatTime(endTime);
      }
      return "-";
    },
    getWxStatusClass(status) {
      if (status == 0) {
        return 'bag-FFA00E'
      }
      if (status == 1) {
        return 'bag-00B99C'
      }
      if (status == 2) {
        return 'bag-FA545E'
      }
      if (status == 3) {
        return 'bag-838AA2'
      }
      return '';
    },
    getWxStatusText(status) {
      if (status == 0) {
        return this.$t('common_46012');
      }
      if (status == 1) {
        return this.$t('common_46013');
      }
      if (status == 2) {
        return this.$t('common_46014');
      }
      if (status == 3) {
        return this.$t('common_46015');
      }
      return '-';
    },
    getWxTitle(row) {
      // 如果有 promotionTitle，优先显示
      if (row.promotionTitle) {
        return row.promotionTitle;
      }
      
      // 根据 type 类型显示活动名称
      switch (row.type) {
        case 8:
          return '组队打榜';
        case 1:
          return '邀请好友';
        case 3:
          return '购买卡券';
        default:
          return '-';
      }
    },
    getActivityTypeText(type) {
      switch (type) {
        case 1:
          return '邀请好友';
        case 2:
          return '储值送返';
        case 3:
          return '购买卡券';
        case 4:
          return '自由领取';
        case 7:
          return '充电送返';
        case 8:
          return '组队打榜';
        default:
          return '-';
      }
    },
    isOpenInCurrentPage() {
      // 判断是否在当前页面打开
      return false;
    },
    time(row) {
      if (row.startTime && row.endTime) {
        return (
          this.formmatTime(row.startTime) +
          " - " +
          this.formmatTime(row.endTime)
        );
      }
      return "-";
    },
    status(row, type) {
      // 微信接口返回的数据中，状态字段是 promotionStatus
      const statusValue = this.isWxPopup ? row.promotionStatus : row.status;

      if (type) {
        if (statusValue == 0) {
          return 'bag-FFA00E'
        }
        if (statusValue == 1) {
          return 'bag-00B99C'
        }
        if (statusValue == 2) {
          return 'bag-FA545E'
        }
        if (statusValue == 3) {
          return 'bag-838AA2'
        }
      } else {
        if (statusValue == 0) {
          return this.$t('common_46012');
        }
        if (statusValue == 1) {
          return this.$t('common_46013');
        }
        if (statusValue == 2) {
          return this.$t('common_46014');
        }
        if (statusValue == 3) {
          return this.$t('common_46015');
        }
        return '-';
      }
    },
    search() {
      if (this.isWxPopup) {
        // 微信模式下不进行搜索，直接重新获取所有数据
        this.getWxPromotionList();
      } else {
        this.params['title'] = this.activityName;
        this.params['status'] = this.statusType === 'all' ? '' : this.statusType;
        var queryString = "";
        var om = this;
        Object.keys(this.params).forEach(function (key) {
          queryString += "&" + key + "=" + om.params[key];
        });
        let type = this.tagMap[this.tag]
        var url = requestUrl + "/promotion?type=" + type + "&from=" + (parseInt(1) - 1) * 4 + "&length=4&returnCount=true" + queryString;
        this.getPromotionList(url);
      }
    },
    handleCurrentChange(val) {
      if (this.isWxPopup) {
        // 微信模式下不进行分页，直接返回
        return;
      }

      this.loading = true;
      var page = val;
      if (this.currentPage == page) {
        return;
      }
      this.currentPage = page;

      var queryString = "";
      var om = this;
      Object.keys(this.params).forEach(function (key) {
        queryString += "&" + key + "=" + om.params[key];
      });
      let type = this.tagMap[this.tag]
      var url = requestUrl + "/promotion?type=" + type + "&from=" + (parseInt(page) - 1) * 4 + "&length=4&returnCount=true" + queryString;
      this.getPromotionList(url);
    },
    getWxPromotionList() {
      const url = requestUrl + "/wechatApp/promotion";
      ajax({
        type: "GET",
        url: url,
        dataType: "json",
        success:  (response)=> {
          try {
            var parsedResponse = JSON.parse(response);
            this.wxTableData = parsedResponse.result || [];
            this.toogleIndex++;
          } catch (e) {
            this.wxTableData = [];
          }
          this.loading = false;
        }
      });
    },
    getPromotionList(url) {
      ajax({
        type: "GET",
        url: url,
        dataType: "json",
        success:  (response)=> {
          try {
            var parsedResponse = JSON.parse(response);
            this.tableData = parsedResponse.result || [];
            for (var i = 0; i < this.tableData.length; i++) {
              this.tableData[i].showInWechat = this.tableData[i].showInWechat && this.tableData[i].showInWechat === 1;
            }
            this.dataNum = parsedResponse.totalCount || 0;
          } catch (e) {
            this.tableData = [];
            this.dataNum = 0;
          }
        }
      });
    },
  },
};
</script>

<style lang="scss">
.active-list {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  .a-items {
    width: 340px;
    height: 196px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    border-radius: 4px;
    border: 1px solid #E6E7EC;
    margin-bottom: 30px;
    box-sizing: border-box;
    color: #1B2330;
    cursor: pointer;
    &.active {
      color: #5278E2;
      border: 2px solid #5278E2;
    }
    p {
      margin-bottom: 10px;
      color: #1B2330;
    }
  }
  .e-table {
    width: 100%;
    height: 320px;
    overflow-y: scroll;
    margin-bottom: 10px;

    // 微信模式下增加表格高度
    &.wx-popup {
      height: 500px;
      overflow: visible;
      min-height: 200px;

      .el-table {
        width: 100% !important;
        height: auto !important;
      }

      .el-table__body-wrapper {
        max-height: 400px;
        overflow-y: auto;
      }
    }
  }
}
</style>
